import { render, staticRenderFns } from "./PDFViewerDialog.vue?vue&type=template&id=5c3036c2&scoped=true&"
import script from "./PDFViewerDialog.vue?vue&type=script&lang=js&"
export * from "./PDFViewerDialog.vue?vue&type=script&lang=js&"
import style0 from "./PDFViewerDialog.vue?vue&type=style&index=0&id=5c3036c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3036c2",
  null
  
)

export default component.exports